import type { SynastryDTO } from '@/api/schema'
import { dayjs } from '@/api/utils/dayjs'
import { Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const SynastryItem: FunctionalComponent<{
  item: SynastryDTO
}> = props => {
  return (
    <UI.Panel
      hover
      link={`/${props.item.type}/${props.item.id}`}
      class={styles.item}
    >
      <Row gap={8}>
        <Text
          fontSize={18}
          fontSizeMobile={16}
          fontWeight={600}
        >
          {props.item.userName}
        </Text>

        <Text
          opacity={0.5}
          fontSize={14}
          fontSizeMobile={13}
        >
          {dayjs(props.item.birthDate).format('D MMMM YYYY')}
          {props.item.birthTime ? `, ${props.item.birthTime?.substring(0, 5)}` : null}
        </Text>
      </Row>

      <div class={styles.type}>
        {props.item.type === 'astro'
          ? <UI.Badge type='violet'>Астрология</UI.Badge>
          : <UI.Badge type='pink'>Матрица</UI.Badge>}
      </div>
    </UI.Panel>
  )
}
